import { Timestamp as FsTimestamp } from 'firebase/firestore';

function isFsTimestamp(v: unknown): v is FsTimestamp {
    return !!v && typeof (v as any).toDate === 'function';
}

export function toJSDate(v: unknown): Date {
    if (v == null) throw new Error('Fecha vacía');
    if (v instanceof Date) return v;
    if (isFsTimestamp(v)) return (v as FsTimestamp).toDate();
    if (typeof v === 'string' || typeof v === 'number') return new Date(v);
    // último intento: si te llega algo raro con { seconds }
    const maybe = v as any;
    if (maybe?.seconds != null && typeof maybe.seconds === 'number') {
        return new Date(maybe.seconds * 1000);
    }
    throw new Error('Formato de fecha no reconocido');
}
